// Project utility functions

export const generateProjectCode = (projectNumber: number): string => {
  const paddedNumber = String(projectNumber).padStart(8, '0');
  return `PR${paddedNumber}`;
};

export const getNextProjectNumber = (existingProjects: any[]): number => {
  if (existingProjects.length === 0) {
    return 1;
  }
  
  const lastProject = existingProjects[existingProjects.length - 1];
  const lastCode = lastProject.kodProjek || lastProject.kod;
  
  // Parse the number from PR00000000 format
  const lastNumber = parseInt(lastCode.replace('PR', ''));
  return lastNumber + 1;
};
